import React, { Component } from 'react'

//mode d'emploi d'installation iOS en 3 étapes, partagé entre la bannière
//d'accueil (PromoteDownload) et la sheet d'opt-in notifications
class IosInstallSteps extends Component {
	//met en gras les segments entre astérisques ("Touchez *Partager*")
	_bold = (text) => {
		const parts = text.split('*')
		return parts.map((part, i) => {
			if (i % 2 === 1)
				return (<strong key={i} className="font-semibold">{part}</strong>)
			return part
		})
	}

	//glyphes iOS redessinés : menu (points), Partager (carré-flèche), Sur l'écran d'accueil (carré-plus)
	_stepIcon = (name) => {
		if (name === "menu")
		{
			return (
				<svg viewBox="0 0 24 24" style={{ width: '24px', height: '24px' }}>
					<circle cx="5" cy="12" r="1.4" fill="#1F2937" />
					<circle cx="12" cy="12" r="1.4" fill="#1F2937" />
					<circle cx="19" cy="12" r="1.4" fill="#1F2937" />
				</svg>
			)
		}
		if (name === "share")
		{
			return (
				<svg viewBox="0 0 24 24" style={{ width: '24px', height: '24px', stroke: '#1F2937', fill: 'none', strokeWidth: 1.8, strokeLinecap: 'round', strokeLinejoin: 'round' }}>
					<path d="M12 3 v11" />
					<path d="M8.5 6.5 L12 3 l3.5 3.5" />
					<path d="M6.5 10 H5.5 a1.5 1.5 0 0 0 -1.5 1.5 v7 a1.5 1.5 0 0 0 1.5 1.5 h13 a1.5 1.5 0 0 0 1.5 -1.5 v-7 a1.5 1.5 0 0 0 -1.5 -1.5 h-1" />
				</svg>
			)
		}
		return (
			<svg viewBox="0 0 24 24" style={{ width: '24px', height: '24px', stroke: '#1F2937', fill: 'none', strokeWidth: 1.8, strokeLinecap: 'round', strokeLinejoin: 'round' }}>
				<rect x="4" y="4" width="16" height="16" rx="4" />
				<path d="M12 8.5 v7 M8.5 12 h7" />
			</svg>
		)
	}

	render() {
		const home = this.props.lang_assets.home
		const chip_style = { width: '44px', height: '44px', borderRadius: '11px', backgroundColor: '#ffffff', border: '1px solid rgba(0, 0, 0, 0.10)', boxShadow: '0 1px 3px rgba(0, 0, 0, 0.10)' }
		//l'étape menu vaut pour tous : Safari (barre compacte) comme Chrome cachent
		//Partager derrière un bouton ⋯, et la disposition n'est pas détectable ;
		//ceux qui voient Partager directement sautent d'eux-mêmes à l'étape 2
		let steps = []
		steps.push({ icon: "menu", label: home.ios_step_menu, hint: null })
		steps.push({ icon: "share", label: home.ios_step_share, hint: null })
		steps.push({ icon: "add", label: home.ios_step_add, hint: home.ios_step_scroll })
		return (
			<div className="mt-3">
				{steps.map((step, i) => (
					<React.Fragment key={i}>
						{i > 0 && <div className="flex justify-center" style={{ width: '44px', color: '#93A8C4', margin: '2px 0' }}>↓</div>}
						<div className="flex items-center space-x-3">
							<span className="flex-none flex items-center justify-center" style={chip_style}>{this._stepIcon(step.icon)}</span>
							<div>
								<p className="text-gray-700" style={{ fontSize: '14.5px', lineHeight: 1.3 }}>{this._bold(step.label)}</p>
								{step.hint && <p className="text-gray-500" style={{ fontSize: '12.5px', lineHeight: 1.3 }}>{step.hint}</p>}
							</div>
						</div>
					</React.Fragment>
				))}
			</div>
		)
	}
}

export default IosInstallSteps
